import React from 'react'
import { Button, Flex, Modal, Text } from '@workwhile/ui'

type ReprocessConfirmModalProps = {
  open: boolean
  selectedCount: number
  isPending: boolean
  onClose: () => void
  onConfirm: () => void
}

export const ReprocessConfirmModal = ({
  open,
  selectedCount,
  isPending,
  onClose,
  onConfirm,
}: ReprocessConfirmModalProps) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Text fontWeight={600} mb={2}>
        Reprocess selected punches?
      </Text>
      <Text mb={3}>
        This will set {selectedCount} punch
        {selectedCount === 1 ? '' : 'es'} back to pending so that{' '}
        {selectedCount === 1 ? 'it is' : 'they are'} processed again.
      </Text>
      <Flex gap={2}>
        <Button variant="primary" disabled={isPending} onClick={onConfirm}>
          {isPending ? 'Reprocessing…' : 'Confirm'}
        </Button>
        <Button variant="secondary" disabled={isPending} onClick={onClose}>
          Cancel
        </Button>
      </Flex>
    </Modal>
  )
}
